module.exports = __webpack_public_path__ + "static/media/Concert.7b04bcf1.jpg";